export const BUSINESS = {
    name: "Dirt Cheapest Sod Corp",
    addressLines: ["7825 Venture Center Way, Apt 4203", "Boynton Beach, FL 33437-7405"],
    addressOneLine: "7825 Venture Center Way, Apt 4203, Boynton Beach, FL 33437-7405",
    phone: "(561) 319-3997",
    phoneHref: "tel:+15613193997",
    email: "dirtcheapsod@gmail.com",
    emailHref: "mailto:dirtcheapsod@gmail.com",
};

export const IMAGES = {
    hero: "https://images.unsplash.com/photo-1561831710-3a8abd9657cf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHxmbG9yaWRhJTIwbGFuZHNjYXBpbmd8ZW58MHx8fHwxNzg4MDQ3MzExfDA&ixlib=rb-4.1.0&q=85",
    sod: "https://images.unsplash.com/photo-1464295440335-ee082a75ccca?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwzfHxzb2QlMjBncmFzcyUyMGZpZWxkJTIwbGFuZHNjYXBlfGVufDB8fHx8MTc4ODA0NzMwMHww&ixlib=rb-4.1.0&q=85",
    nursery: "https://images.unsplash.com/photo-1653842647601-c84c4ce6f9fe?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwzfHxwbGFudCUyMG51cnNlcnklMjBncmVlbmhvdXNlfGVufDB8fHx8MTc4ODA0NzMwMHww&ixlib=rb-4.1.0&q=85",
};
